// S6-2 — **THE SITE FOOTER, AND THE ONE PAGE THAT DOES NOT GET ONE.**
//
// Her ruling: *"the site footer is REMOVED from the inbox list view and the thread view entirely,
// both mobile and desktop — nobody needs a footer in their mail. The reclaimed space goes to
// messages; the composer sits at the TRUE bottom."*
//
// **IT IS A COMPONENT RATHER THAN A TERNARY IN App.tsx FOR THE REASON ROADMAP 7 EXISTS:** a decision
// written inline in a 12,000-line TSX file can be read by a regex and RUN by nothing. This is
// hookless and takes props, so `scripts/s6-honest-labels.mjs`'s sibling gate CALLS it once per page
// and reads the tree back — which is the difference between *the word `inbox` appears near the word
// `footer`* and *this page really renders no footer*.
//
// **THE DECISION IS THE PAGE ID, NEVER A VIEWPORT**, because her ruling names both; and the footer is
// not RENDERED rather than hidden by a rule, because a hidden footer still occupies the document —
// which is exactly what stood between the composer and the true bottom of the screen.
import { pageIsStandalone, type Page } from "../lib/pages";

// The pages that get no footer. A ROSTER rather than a comparison, so the next page she takes it off
// joins by being named here and the law stays in one place (R28/R29). `inbox` is one page id and the
// thread view is the same page, so her "list view AND thread view" is covered by construction.
export const FOOTERLESS_PAGES: Page[] = [
  "inbox",
  // HER SIGNUP PAGE: her artwork IS the page (the mockup-matching law), and the house footer under
  // it is the reinterpretation that law refuses -- the same reason her stranger home has none.
  "signup",
];

// **L1 (2026-08-13) — A STANDALONE PAGE HAS NO FOOTER BY DERIVATION, NEVER BY A SECOND ROSTER ENTRY.**
// Her ruling is that `/funnel` wears no house chrome at all, and the footer is house chrome. Writing
// `funnel` into `FOOTERLESS_PAGES` as well would be two answers to one question (R28/R29) that agree
// today and drift the first time either roster moves; asking the standalone law here means the next
// standalone page joins by EXISTING. The two rosters stay separate because they are separate facts
// (R18): `inbox` draws every other piece of chrome and only loses its footer.
// **HOME-1 FINAL (2026-08-17) — AND `home` IS TWO SURFACES, WHICH IS WHY A PAGE ID CANNOT ANSWER
// THIS ALONE (R18).** Her clause on the signed-out home: *"her artwork is the page's only surface...
// NO LAYER OF THE OLD PAGE EXISTS ANYWHERE SIGNED-OUT."* The footer is a layer of the old page, and
// it was rendering under her artwork -- visible in the capture, below her cards.
//
// A signed-IN member's home keeps it, because her clause is scoped to the stranger. So the surface
// is a SECOND FACT rather than a second roster entry, and it **DEFAULTS TO FALSE, so every existing
// caller is byte-identical** (ITEM 12's neutrality argument): the only page that loses a footer is
// the one she named.
export function siteFooterHidden(page: Page, strangerHome = false): boolean {
  return FOOTERLESS_PAGES.includes(page) || pageIsStandalone(page) || (strangerHome === true && page === "home");
}

export function SiteFooter({ page, note, strangerHome = false }: { page: Page; note: string; strangerHome?: boolean }) {
  if (siteFooterHidden(page, strangerHome)) return null;
  return (
    <footer>
      <p>{note}</p>
    </footer>
  );
}
